export default __webpack_public_path__ + "static/media/1.d0a96335.jpg";